import { SHIPPING_RATE_LOGS_ACTIONS } from './shippingRateLogs.types';
export const setShippingRateLogsAction = (payload) => ({
    type: SHIPPING_RATE_LOGS_ACTIONS.SET_LOGS,
    payload
});
export const setShippingRateLogAction = (payload) => ({
    type: SHIPPING_RATE_LOGS_ACTIONS.SET_LOG,
    payload
});
export const setShippingRateLogsStatusAction = (payload) => ({
    type: SHIPPING_RATE_LOGS_ACTIONS.SET_STATUS,
    payload
});
export const setShippingRateLogsErrorsAction = (payload) => ({
    type: SHIPPING_RATE_LOGS_ACTIONS.SET_ERRORS,
    payload
});
export const clearShippingRateLogsErrorsAction = () => ({
    type: SHIPPING_RATE_LOGS_ACTIONS.CLEAR_ERRORS
});
export const setShippingRateLogsMetaAction = (payload) => ({
    type: SHIPPING_RATE_LOGS_ACTIONS.SET_META,
    payload
});
